import { createFileRoute } from "@tanstack/react-router";
import { DashboardLayout } from "@/components/dashboard/DashboardLayout";
import { ModelSwipeReview } from "@/components/models/ModelSwipeReview";
import { AudioSection, HeroHeader, ImageSection, VideoSection } from "@/components/models/ModelsContent";

export const Route = createFileRoute("/dashboard/models")({
	component: DashboardModelsPage,
	head: () => ({
		meta: [
			{ title: "Model Library, AgentFramer" },
			{
				name: "description",
				content:
					"Access the world's most powerful image, video, and audio generation models through a single MCP integration.",
			},
		],
	}),
});

function DashboardModelsPage() {
	return (
		<DashboardLayout>
			<ModelSwipeReview />
			<HeroHeader />
			<ImageSection />
			<VideoSection />
			<AudioSection />
		</DashboardLayout>
	);
}
